import { NativeSelect } from '@mantine/core'
import { useEffect } from 'react'
import useApi from '../hooks/useApi'

const BranchDropdown = ({ branch, setBranch }) => {
  const { data: branches, isLoading: branchLoading } = useApi({ url: '/salesassist/cplusassist/branches', initial: [] })

  useEffect(() => {
    if (branches.length === 0) return
    setBranch(branches[0].MamCode)
  }, [branches])

  if (branchLoading) return <NativeSelect value={null} placeholder="Loading..." disabled={true} />

  return (
    <NativeSelect
      value={branch}
      onChange={(e) => setBranch(e.currentTarget.value)}
      data={branches.map((b) => ({ value: b.MamCode, label: `[${b.MamCode}] ${b.Branch}` }))}
    />
  )
}

export default BranchDropdown
